import React, { useState } from "react";
import {  useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Tooltip, Menu, ListItemIcon, IconButton, MenuItem, Modal, Box, FormControl, TextField } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import RenameFile from "./rename-file";
import DeleteFile from "./delete-file";
import host from "../host";
import { changeAuth } from "../actions/loginAction";
export default function FileActions(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const onClose = () => {
    setSnackbar(false);
  };
  const [open, setOpen] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openhistoryaction = Boolean(anchorEl);
  const handleClickaction = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //this below function for openknowledge     popup start//
  const [openeditfile, setOpeneditfile] = React.useState(false);
  const [renameFile, setRenameFile] = useState({ id: null, newName: "" });
  const activeeditfile = (fileId, currentName) => {
    setRenameFile({ id: fileId, newName: currentName });
    setOpeneditfile(true);
  };
  const handleCloseeditfile = () => {
    setOpeneditfile(false);
    setRenameFile({ id: null, newName: "" }); // Reset the rename state
  };
  const handleNewNameChange = (event) => {
    setRenameFile({ ...renameFile, newName: event.target.value });
  };
  //this below function for openknowledge     popup end//

  //this below function for delete member   popup start//
  const [opendelete, setOpendelete] = React.useState(false);
  const activedelet = () => setOpendelete(true);
  const handleClosedelete = () => setOpendelete(false);
  //this below function for delete member   popup end//

  //rename functionality starts
  const handleRename = (knowledge_id) => {
    fetch(host.chaturl + `/knowledge/file/${knowledge_id}/rename?new_file_name=${renameFile.newName}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          props.getKnowledge();
          setSeverity("success");
          setMessage("File name changed successfully");
          setSnackbar(true);
          handleCloseeditfile();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  //rename functionality ends

  //download pdf functionality start
  const handleDownload = async (fileUrl, fileName) => {
    try {
      // Fetch the PDF file
      const response = await fetch(fileUrl);
      const pdfBlob = await response.blob();

      // Create a URL for the Blob
      const url = URL.createObjectURL(pdfBlob);

      // Create an anchor element
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.setAttribute("download", fileName ? fileName : "document.pdf");

      // Trigger download
      document.body.appendChild(anchor);
      anchor.click();

      // Clean up
      document.body.removeChild(anchor);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  //download pdf functionality end
  return (
    <>
      <Tooltip title="Actions">
        <IconButton onClick={handleClickaction} size="small" aria-controls={open ? "account-menu" : undefined} aria-haspopup="true" aria-expanded={open ? "true" : undefined}>
          <MoreHorizIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={openhistoryaction}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={() => activeeditfile(props.pdfId, props.pdfFileName)}>
          <ListItemIcon>
            <EditNoteOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Rename File
        </MenuItem>
        {/* <MenuItem>
          <ListItemIcon>
            <ShareOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Share
        </MenuItem> */}
        <MenuItem onClick={() => handleDownload(props.pdfFilePath, props.pdfFileName)}>
          <ListItemIcon>
            <FileDownloadOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Download File
        </MenuItem>
        <MenuItem onClick={activedelet}>
          <ListItemIcon>
            <DeleteOutlineOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Delete File
        </MenuItem>
        <MenuItem onClick={() => props.handleChatSpecificDoc(props.pdfData)} disabled={props.pdfData.status !== 'completed'}>
          <ListItemIcon>
            <EditNoteOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Start Chat
        </MenuItem>
      </Menu>
      <RenameFile fileId={props?.pdfId} fileName={props?.pdfFileName} openeditfile={openeditfile} handleCloseeditfile={handleCloseeditfile} getKnowledge={props?.getKnowledge} />
      <DeleteFile opendelete={opendelete} handleClosedelete={handleClosedelete} brain={props.pdfData} setSnackbar={setSnackbar} setSeverity={setSeverity} setMessage={setMessage}/>

      {/* <Modal open={openeditfile} onClose={handleCloseeditfile} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className=" commonpopup  modal-common   popup-w35 ">
          <div className="modal-body">
            <div className="card-item__content   mb-2">
              <div class="card-title">
                <h2>Rename File</h2>
                <span>Please provide a new name for {renameFile.newName}</span>
              </div>
              <Link className="close" onClick={handleCloseeditfile}>
                X
              </Link>
            </div>
            <div className="popup-knowledge">
              <div className="col-md-12">
                <div className="form-group">
                  <label>File Name</label>
                  <FormControl fullWidth size="small">
                    <TextField id="outlined-multiline-flexible" value={renameFile.newName} onChange={handleNewNameChange} placeholder="Edit File Name" multiline />
                  </FormControl>
                </div>
                <div className="col-12 mt-3">
                  <div className="modal-btn">
                    <button type="button" className="btn btn-default w-50" onClick={handleCloseeditfile}>
                      Cancel
                    </button>
                    <button type="button" className="btn btn-primary w-50" onClick={() => handleRename(renameFile.id)}>
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal> */}
    </>
  );
}
